export default __webpack_public_path__ + "static/media/comingsoon_corner.a8aae1b4.svg";